<template>
  <div>
    <b-row>
      <b-col lg="12" cols="12" order="1" order-lg="1">
        <b-card>
          <router-view :key="$route.path" />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BContainer, BCard, BCardText } from "bootstrap-vue";
export default {
  components: { BRow, BCol, BContainer, BCard, BCardText },
  beforeDestroy() {
    if (this.$store.hasModule("NgoPlan"))
      this.$store.unregisterModule("NgoPlan");
  },
};
</script>
